import ApiService from "@/services/base";
import { FILTER_VALUES } from "@/constants/filters";
import { config } from "@/utils/config";
let UsageService = class UsageService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    /**
   * Get hourly usage for a specific day
   */ async getHourlyUsage(contractId, dayUtc, apiKeyId, customerId) {
        const params = new URLSearchParams({
            dayUtc
        });
        if (apiKeyId && apiKeyId !== FILTER_VALUES.ALL) {
            params.append("apiKeyId", apiKeyId);
        }
        if (customerId) {
            params.append("customerId", customerId);
        }
        const response = await this.get({
            url: `/direct/usage/hourly/${contractId}?${params.toString()}`
        });
        return response.data;
    }
    /**
   * Get daily aggregated usage for a date range
   */ async getDailyAggregatedUsage(contractId, startDate, endDate, apiKeyId, customerId) {
        const params = new URLSearchParams({
            startDate,
            endDate
        });
        if (apiKeyId && apiKeyId !== FILTER_VALUES.ALL) {
            params.append("apiKeyId", apiKeyId);
        }
        if (customerId) {
            params.append("customerId", customerId);
        }
        const response = await this.get({
            url: `/direct/usage/daily/${contractId}?${params.toString()}`
        });
        return response.data;
    }
    /**
   * Get metered usage by contract with API key totals
   */ async getMeteredUsage(contractId, startDate, endDate, apiKeyId, customerId) {
        const params = new URLSearchParams({
            startDate,
            endDate
        });
        if (apiKeyId && apiKeyId !== FILTER_VALUES.ALL) {
            params.append("apiKeyId", apiKeyId);
        }
        if (customerId) {
            params.append("customerId", customerId);
        }
        const response = await this.get({
            url: `/direct/usage/metered/${contractId}?${params.toString()}`
        });
        return response.data;
    }
    /**
   * Create metered usage record
   */ async createMeteredUsage(apiKeyId, data) {
        const response = await this.post({
            url: `/direct/usage/metered/${apiKeyId}`,
            data
        });
        return response.data;
    }
};
export default UsageService;
